import { simplePath } from "../utils.js";
const GET_ORG_PEOPLE_LIST_PATH = "/v2/organization/:organization/people-list";
function get_org_people_list_path(params) {
    return simplePath(GET_ORG_PEOPLE_LIST_PATH, params);
}
export { GET_ORG_PEOPLE_LIST_PATH, get_org_people_list_path };
